import { render, staticRenderFns } from "./banner.vue?vue&type=template&id=08b8f355&"
import script from "../assets/js/banner.js?vue&type=script&lang=js&"
export * from "../assets/js/banner.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports